export const iconFontAwesomeBuildingsBuildingWheat = (
	<i className="fa-solid fa-building-wheat"></i>
);
